export var INLINE_CALENDAR = 'inline';
export var POPUP_CALENDAR = 'popup';